export default __webpack_public_path__ + "static/media/lightbulb.a6906c2d.svg";